import { paymentApi } from "../../services/api/paymentApi";
import { host } from "../../services/http"; 

const state = {
  sidebar: {
    opened: false,
    withoutAnimation: false,
  },
  config: {
    googleMaps: {
      apiKey: 'AIzaSyBNAqPrTQoz9P4NBlDDyfxrnKiafkaL8iQ',
    },
    windowMatchSizeLg: '(min-width: 992px)',
    palette: {
      primary: '#4ae387',
      danger: '#e34a4a',
      info: '#4ab2e3',
      success: '#db76df',
      warning: '#f7cc36',
      white: '#fff',
      black: '#000',
      fontColor: '#34495e',
      transparent: 'transparent',
      lighterGray: '#ddd',
    },
  },
  isLoading: true,
  popup: {
    invoice: false
  },
  invoice: {
    number: "",
    tripId: 0,
    participantId: 0,
    paymentId: 0

  }
}

const mutations = {
  setLoading(state, isLoading) {
    state.isLoading = isLoading
  },
  'TOGGLE_WITHOUT_ANIMATION'(state, value) {
    state.sidebar.withoutAnimation = value
  },

  user(state, userObject) {
    state.user = userObject
  },
  openPopup(state, value) {
    if (value == 'invoice') {
      state.popup.invoice = true
    }
  },

  closePopup(state, value) {
    if (value == 'invoice') {
      state.popup.invoice = false
    }
  },

  setInvoiceNumber(state, value) {
    state.invoice.number = value
  },

  setInvoiceDownloadUrl(state, value) {
    state.invoice.downloadUrl = value
  },

  setInvoiceData(state, value) {
    state.invoice.tripId = value.tripId
    state.invoice.participantId = value.participantId
    state.invoice.paymentId = value.paymentId
  }

}

const actions = {
  isToggleWithoutAnimation({ commit }, value) {
    commit('TOGGLE_WITHOUT_ANIMATION', value)
  },

  openPopup({ commit }, value) {
    commit('openPopup', value)
  },

  setSelectedInvoiceData({commit}, value) {
    commit('setInvoiceData', value)
  },

  closePopup({ commit }, value) {
    commit('closePopup', value)
  },

  generateInvoice({commit, state}, value) {
    commit('setLoading', true)
    commit('setInvoiceNumber', value)
    //async call
    //open popup
    let invoice = state.invoice
    paymentApi
    .generateInvoice(
      invoice.tripId,
      invoice.participantId,
      invoice.paymentId,
      invoice.number
    )
    .then((doc) => {
      console.log(JSON.stringify(doc));
      commit('setInvoiceDownloadUrl', doc.file)

      let url =  doc.file
      const link = document.createElement("a");
      link.href = `${host}${url}`;
      console.log("Download url = " + `${host}${url}`);
      
      link.setAttribute("download", "file.docx");
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();

      commit('setLoading', false)
    })
    .catch(m => {
      commit('setLoading', false)
    });
  },

  generateCreditPayment({commit, state}, value) {
    commit('setLoading', true)
    commit('setInvoiceNumber', value)
    //async call
    //open popup
    let invoice = state.invoice
    paymentApi
    .generateCredit(
      invoice.tripId,
      invoice.participantId,
      invoice.paymentId,
      invoice.number
    )
    .then((doc) => {
      commit('setInvoiceDownloadUrl', doc.file)

      let url =  doc.file
      const link = document.createElement("a");
      link.href = `${host}${url}`;
      link.setAttribute("download", "creadit.docx");
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();

      commit('setLoading', false)
    })
    .catch(m => {
      commit('setLoading', false)
    });
  },

  downloadDocument( {commit, state}, value) {
    //TODO: test it
    let url =  state.invoice.downloadUrl
    const link = document.createElement("a");
    link.href = `${host}${url}`;
    link.setAttribute("download", "file.docx");
    link.setAttribute("target", "_blank");
    document.body.appendChild(link);
    link.click();
  }
}

export default {
  state,
  mutations,
  actions,
}
